import config from "./components/config";
import loadI18N from "./components/i18n";
import loadVariables from "./components/variables";
import loadNavbar from "./components/navbar";
import loadWidget from "./components/widget";

loadVariables();
loadI18N();

if (config.modules.includes('a11y-nav')) {
  loadNavbar();
}

loadWidget();